/** @format */

import React, { FC, useState, useEffect } from 'react'
import { _$, Card, Tabs, Message, Tab, Select, Option } from 'kpc-react'
import styled from 'styled-components'
import moment from 'moment'
import QuickRangeDate from 'src/components/QuickRangeDate'
import MonitorCrumb from 'src/components/MonitorCrumb'
import { MonitorSearch } from 'src/components'
import TacticsList from 'src/containers/MonitorHistoryTactics/TacticsList'
import EventList from 'src/containers/MonitorHistoryTactics/AlarmEventList'
import { DateTimeProps } from 'src/containers/MonitorHistoryTactics/constants'
import { eventListToOptions, EventOptions } from 'src/pages/EventCenter/constants'
import useNavRegion from 'src/hooks/useNavRegion'
import { request } from 'src/utils'
import API from 'src/api/ApiEventCenter'
interface Props {
  className?: string
}

// 告警历史
const HistoryTabs = [
  {
    text: '阈值告警',
    value: 'threshold'
  },
  {
    text: '事件告警',
    value: 'event'
  }
]

const MonitorAlarmHistory: FC<Props> = ({ className }) => {
  // 控制台region
  const region = useNavRegion()

  const [dateTime, setDateTime] = useState<DateTimeProps>({
    StartTime: null,
    EndTime: null
  })
  const [query, setQuery] = useState<string>('')
  const [queryType, setQueryType] = useState<'InstanceId' | 'PolicyName'>('InstanceId')
  const [tabValue, setTabValue] = useState<'threshold' | 'event'>('threshold')
  const [eventProduct, setEventProduct] = useState<number>(999)
  const [eventProductList, setEventProductList] = useState<EventOptions[]>([])

  useEffect(() => {
    if (tabValue === 'event' && !eventProductList?.length) {
      getEventList()
    } else {
      setEventProduct(999)
    }
    setQuery('')
  }, [tabValue])

  // 获取所有事件
  const getEventList = async () => {
    const result = await request(API.getListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      setEventProductList(eventListToOptions(result?.data.eventList) as EventOptions[])
      return result
    } else {
      Message.error(result?.message)
      return null
    }
  }

  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('告警历史') }]} />
      <Card>
        <div className="header">
          <QuickRangeDate
            format="YYYY-MM-DD HH:mm"
            optionalDateRange={30}
            defautlValue={'近1小时'}
            quickRange={['近1小时', '近1天', '近3天', '近1周']}
            changeValue={(date, quick) => {
              setDateTime({
                StartTime: date[0] ? moment(date[0]).unix() * 1000 : undefined,
                EndTime: date[1] ? moment(date[1]).unix() * 1000 : undefined
              })
            }}
          />
          <div className="query-box">
            <MonitorSearch
              prepend={
                tabValue === 'threshold' ? (
                  <React.Fragment>
                    <Select
                      value={queryType}
                      on$change-value={(c, value) => setQueryType(value)}
                      width="110"
                    >
                      <Option value="InstanceId">{_$('实例Id')}</Option>
                      <Option value="PolicyName">{_$('策略名称')}</Option>
                    </Select>
                  </React.Fragment>
                ) : null
              }
              placeholder={
                tabValue === 'threshold'
                  ? queryType === 'InstanceId'
                    ? _$('输入实例ID')
                    : _$('请输入策略名称')
                  : _$('输入实例ID')
              }
              value={query}
              onChange={value => {
                setQuery(value)
              }}
            />
          </div>
        </div>

        <Tabs value={tabValue} on$change-value={(c, tab) => setTabValue(tab)}>
          {HistoryTabs.map(({ text, value }) => (
            <Tab key={value} value={value}>
              {_$(text)}
            </Tab>
          ))}
        </Tabs>
        <div className="marginTop">
          {tabValue === 'threshold' ? (
            <TacticsList region={region} dateTime={dateTime} query={query} queryType={queryType} />
          ) : (
            <EventList
              region={region}
              dateTime={dateTime}
              query={query}
              eventProduct={eventProduct}
              eventProductList={eventProductList}
            />
          )}
        </div>
      </Card>
    </div>
  )
}

export default styled(MonitorAlarmHistory)`
  .k-tabs {
    margin-top: 8px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`
